import React from 'react';

const FlashIcon = ({ stroke }) => {
  return (
    <svg width='23' height='18' viewBox='0 0 23 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_375_214)'>
        <path
          d='M14.0455 1.48325L4.85434 10.3754H10.2197L8.89892 16.0596C8.8964 16.0707 8.89705 16.0822 8.9008 16.0931C8.90455 16.104 8.91132 16.1142 8.92063 16.1229C8.92995 16.1315 8.94157 16.1385 8.9547 16.1432C8.96782 16.148 8.98212 16.1505 8.99658 16.1504V16.1504C9.01198 16.1504 9.02715 16.1476 9.04091 16.1422C9.05466 16.1368 9.06661 16.1289 9.07581 16.1193L18.2678 7.22544H12.9024L14.2295 1.54067C14.2313 1.52935 14.23 1.51786 14.2257 1.50696C14.2213 1.49606 14.2141 1.48601 14.2044 1.47748C14.1947 1.46894 14.1828 1.46211 14.1695 1.45745C14.1562 1.45279 14.1418 1.4504 14.1272 1.45044V1.45044C14.1113 1.45049 14.0956 1.45349 14.0813 1.45919C14.0671 1.46489 14.0549 1.47313 14.0455 1.48325V1.48325Z'
          stroke={stroke}
          strokeWidth='1.20227'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_375_214'>
          <rect
            width='21.4615'
            height='16.8'
            fill='white'
            transform='translate(0.83075 0.399902)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlashIcon;
